import React from "react";
import Style from '../Styles/Common.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const AboutMaadaddressComponent = ()=>{
    return(
        <div className={Style.mayogallerysec+"  "+Style.maadAddress}>
        <Container>
            <Row>
                <Col>
                    <div className={Style.addressinfo}style={{padding:"0px"}}>
                        <ul>
                            <li>Address : C 39, Niti Bagh, New Delhi - 110049, India</li>
                            <li className={Style.last}>Email: <a href="mailto:secretary@mayoalumni.in">secretary@mayoalumni.in</a></li>
                        </ul>
                        <ul>
                            <li>Phone no. : +91 98 1186 8683</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    )
}

export default AboutMaadaddressComponent;